
const Textarea = ({
  label,
  errors,
  name,
  touched,
  className,
  inputClassName,
  type,
  maxLength = 140, // Default maxLength value
  charCount,
  ...rest
}) => {
  return (
    <div className={`textarea position-relative ${className || "title-size"}`}>
      {label && <label>{label}</label>}
      <br />
      <textarea
        type={type}
        {...rest}
        className={inputClassName + " " + "input-bg h_100 w-100" || ""}
      />
      {errors && <div className="description-error">{errors}</div>}

      {/* Character Count */}
      <div
        className="input-helpertext"
      >
      </div>
    </div>
  );
};

export default Textarea;

